import { SearchFieldKeys, SearchParameterKeys, TableColumn } from "@sso/types";

import { TraccUsageKeys } from "../../constant/traccUsage";
import { calculationTypeOption } from "../../types/traccUsage";

export const traccUsageTableColumns: TableColumn<TraccUsageKeys>[] = [
  {
    name: "Name",
    field: TraccUsageKeys.FULL_NAME,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Email",
    field: TraccUsageKeys.EMAIL,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Organisation",
    field: TraccUsageKeys.ORGANISATION_NAME,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Calculation",
    field: TraccUsageKeys.CALCULATION_TYPE,
    search: {
      type: SearchFieldKeys.SELECT,
      searchParamaterKey: SearchParameterKeys.EQUAL,
      options: calculationTypeOption,
    },
  },
  {
    name: "Created",
    field: TraccUsageKeys.CREATED_AT,
    sortable: true,
    search: { type: SearchFieldKeys.DATE_RANGE },
  },
];
